import React from 'react';

import { Link } from 'react-router-dom';

const HeroNine = () => {
  return (
    <section
      className='hero-it-solution hero-nine-bg ptb-120'
      style={{
        background: "url('assets/img/hero-9-img.png')no-repeat",
        backgroundSize: 'cover',
      }}
    >
      <div className='container'>
        <div className='row align-items-center'>
          <div className='col-lg-12 col-md-10'>
            <div className='hero-content-wrap mt-5 mt-lg-0 mt-xl-0'>
              <h1 className='fw-bold display-5'>Softwareentwicklung</h1>
              <p className='lead'>
                Gemeinsam mit Ihnen entwickeln wir innovative IT-Lösungen, die
                die Zukunft gestalten und Ihr Unternehmen voranbringen
              </p>
              <div className='action-btn mt-5 align-items-center d-block d-sm-flex d-lg-flex d-md-flex'>
                <Link to='/contact-us' className='btn btn-primary me-3'>
                  Kontaktieren Sie uns
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroNine;

